import { render, staticRenderFns } from "./SyncBracketInventory.vue?vue&type=template&id=52d66b70&scoped=true&"
import script from "./SyncBracketInventory.vue?vue&type=script&lang=js&"
export * from "./SyncBracketInventory.vue?vue&type=script&lang=js&"
import style0 from "./SyncBracketInventory.vue?vue&type=style&index=0&id=52d66b70&scoped=true&lang=css&"
import style1 from "./SyncBracketInventory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d66b70",
  null
  
)

export default component.exports